import { DateTime } from 'luxon';

const Views = self => ({
  get isActive() {
    if (self.eligibleForFreeTrial || self.isExpired) { return false; }

    return self.startDate && DateTime.fromJSDate(self.startDate).startOf('day') < DateTime.now();
  },

  get isActivatedFromBackoffice() {
    const isActiveFreeTrial = Boolean(self.isStarted && !self.isExpired);
    const isBackofficeSource = self.source?.toLowerCase() === 'backoffice';

    return isActiveFreeTrial && isBackofficeSource;
  },

  get isScheduled() {
    return self.startDate && self.startDate >= Date.now();
  },

  get trialDaysLeft() {
    if (!self.isActive) { return false; }

    const diff = Math.floor(DateTime.fromJSDate(self.endDate).endOf('day').diff(DateTime.now(), 'days').days);

    return diff < 0 ? 0 : diff;
  },
});

export default Views;
